import { NEXT_SCENE } from "../../../gameStateEventTrigger.js";
import { StatScreenRender } from "./statScreenRender.js";
export class StatScreenScene {
    constructor(sceneTrigger, levelSummary) {
        this.sceneTrigger = sceneTrigger;
        this.levelSummary = levelSummary;
    }
    onEnter(sceneManager) {
        const screenRenderer = new StatScreenRender(this.levelSummary);
        sceneManager.addUIEntity(screenRenderer);
        setTimeout(() => {
            this.onExit();
        }, 6000);
    }
    onResume(sceneManager) {
    }
    onExit() {
        this.sceneTrigger.assertChange(null, NEXT_SCENE);
    }
    update(context) { }
    draw(context) { }
}
